import { BaseComponentRegistry } from "@/Common/Modularity/BaseComponentRegistry";
import { createRegistryListView } from "@/Common/Modularity/Components/ComponentRegistryWrapper";

/**
 * Component IDs in the portfolio page registry.
 */
enum PortfolioPageRegistryComponentId {
    CnesstForms
}

/**
 * Props for the portfolio page registry.
 */
interface IPortfolioPageRegistryProps {
    componentId: PortfolioPageRegistryComponentId;
}

/**
 * Registry for the portfolio page components.
 */
class PortfolioPageRegistry extends BaseComponentRegistry<PortfolioPageRegistryComponentId, IPortfolioPageRegistryProps> {}

/**
 * React component for the portfolio page registry.
 */
const PortfolioPageRegistryView = createRegistryListView(() => PortfolioPageRegistry.getInstance());

export {
    IPortfolioPageRegistryProps,
    PortfolioPageRegistry,
    PortfolioPageRegistryComponentId,
    PortfolioPageRegistryView
};
